/**
 * "🕘 Data as of Sep 28, 2026 (from Eclipse)": how current the numbers on
 * the page are.
 */

import { useTranslation } from "react-i18next";
import { date } from "../format";

export function FreshLine({ asOf }: { asOf: string | null }) {
  const { t } = useTranslation();
  return (
    <div
      role="status"
      // Takes its text color from where it's placed (grey in the header)
      className="inline-flex items-center gap-[5px] whitespace-nowrap text-si-sm leading-[1.3] tabular-nums"
    >
      {/* Clock icon */}
      <svg
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2.2"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
        className="h-[13px] w-[13px] flex-none"
      >
        <circle cx="12" cy="12" r="9" />
        <path d="M12 7v5l3 2" />
      </svg>
      {/* The date the data runs through */}
      {t("pages.pcInsights.fresh.asOf", { date: date(asOf) })}
    </div>
  );
}
